const optionFallback = (index: number) => `Option ${index + 1}`;

export const optionsWithFallback = (
  options: { label: string; value: string }[] | null | undefined,
) =>
  (options?.length ? options : [{ label: "", value: "" }]).map(
    (option, idx) => ({
      value: option.value || optionFallback(idx),
      label: option.label || optionFallback(idx),
    }),
  );
